import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { ExtraExecutionResultModel } from "../../models/api/extra-execution-result.model";
import { PostcodesModel } from "../../models/geolocation/postcodes-model";

@Injectable({
    providedIn: "root"
})
export class PostcodesGeolocationService {
    private readonly API_GET_COORDINATES_URL = "https://api.postcodes.io/postcodes/";

    public constructor(
        private _http: HttpClient
    ) {
    }

    public getCoordinatesByPostcode(postcode: string): Observable<ExtraExecutionResultModel<PostcodesModel>> {
        const requestUrl = this.API_GET_COORDINATES_URL + postcode;
        return this._http.get<ExtraExecutionResultModel<PostcodesModel>>(requestUrl);
    }
}
